"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const contexts_1 = require("@App/contexts");
const RequireFeatureFlag_1 = __importDefault(require("@Components/RequireFeatureFlag"));
const UserMenu = () => {
    const [panelIsOpen, setPanelIsOpen] = (0, react_1.useState)(false);
    const [mouseOverPanel, setMouseOverPanel] = (0, react_1.useState)(false);
    const [loaderOpen, setLoaderOpen] = (0, react_1.useState)(false);
    const { userStore, authStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const logOut = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoaderOpen(true);
        yield authStore.logOut();
        setLoaderOpen(false);
        navigate(navigation_1.default.login.root());
    });
    const userInfo = userStore.userInfo;
    const firstName = userInfo && userInfo.firstName;
    const lastName = userInfo && userInfo.lastName;
    const email = userInfo && userInfo.email;
    const avatar = firstName && lastName ? `${firstName.substr(0, 1)}${lastName.substr(0, 1)}` : 'MLC';
    const classNames = ['user-menu-component', panelIsOpen ? 'active' : ''].join(' ');
    return (react_1.default.createElement("div", { className: classNames, "data-testid": "user-menu-component", title: 'User Menu' },
        react_1.default.createElement("span", { className: "bold" }, avatar),
        react_1.default.createElement("label", { htmlFor: "user-trigger", className: "user-panel", title: '', onMouseMove: () => setMouseOverPanel(true), onMouseOut: () => setMouseOverPanel(false) },
            react_1.default.createElement("div", { className: "user-info" },
                react_1.default.createElement("div", { className: "user-avatar" },
                    react_1.default.createElement("h3", null, avatar)),
                react_1.default.createElement("div", { className: "user-details" },
                    react_1.default.createElement("p", { className: "user-name", title: firstName + ' ' + lastName },
                        firstName,
                        " ",
                        lastName),
                    email && (react_1.default.createElement("p", { className: "user-email", title: email }, email)))),
            loaderOpen ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement("div", { className: "user-options" },
                react_1.default.createElement(RequireFeatureFlag_1.default, { flagKey: 'courier-notifications' },
                    react_1.default.createElement(react_router_dom_1.NavLink, { className: "notification-preferences-link", to: navigation_1.default.notification.preferences(), onClick: () => setPanelIsOpen(false) }, "Notification Preferences")),
                react_1.default.createElement(react_router_dom_1.NavLink, { className: "preferences-link", to: navigation_1.default.profile.root(), onClick: () => setPanelIsOpen(false) }, "Profile"),
                react_1.default.createElement("p", { className: "logout-link small", onClick: logOut }, "Log out")))),
        react_1.default.createElement("input", { type: "text", id: "user-trigger", onBlur: () => setPanelIsOpen(mouseOverPanel), onClick: () => setPanelIsOpen(true), defaultChecked: true }),
        react_1.default.createElement("label", { className: "user-trigger", htmlFor: "user-trigger" })));
};
exports.default = UserMenu;
